import Vue from "vue";
var CustomerOrderStore = /** @class */ (function () {
    function CustomerOrderStore() {
        this.weeeOrderCreateRequest = null;
    }
    CustomerOrderStore.prototype.getWeeeOrderCreateRequest = function () {
        try {
            var value = localStorage.getItem("weee-weeeordercreaterequest");
            if (!value)
                return null;
            return JSON.parse(value);
        }
        catch (err) {
            return null;
        }
    };
    CustomerOrderStore.prototype.setWeeeOrderCreateRequest = function (value) {
        localStorage.setItem("weee-weeeordercreaterequest", JSON.stringify(value));
    };
    CustomerOrderStore.prototype.removeWeeeOrderCreateRequest = function () {
        localStorage.removeItem("weee-weeeordercreaterequest");
    };
    CustomerOrderStore.prototype.getWeeeOrderItems = function () {
        try {
            var value = localStorage.getItem("weee-weeeorderitems");
            if (!value)
                return null;
            return JSON.parse(value);
        }
        catch (err) {
            return null;
        }
    };
    CustomerOrderStore.prototype.setWeeeOrderItems = function (value) {
        localStorage.setItem("weee-weeeorderitems", JSON.stringify(value));
    };
    CustomerOrderStore.prototype.removeWeeeOrderItems = function () {
        localStorage.removeItem("weee-weeeorderitems");
    };
    return CustomerOrderStore;
}());
export { CustomerOrderStore };
var customerOrderStoreVm = new Vue({ data: { customerOrderStore: new CustomerOrderStore() } });
export var customerOrderStore = customerOrderStoreVm.$data["customerOrderStore"];
